import { useSite } from "@/lib/site";
import { Link } from "react-router-dom";
import { Megaphone } from "lucide-react";

export default function AnnouncementBanner() {
  const { site } = useSite();
  const banner = site?.announcement_banner;
  if (!banner?.enabled || !banner.message) return null;
  return (
    <div data-testid="announcement-banner" className="bg-primary text-white text-xs md:text-sm">
      <div className="max-w-[1400px] mx-auto px-6 py-2 flex items-center gap-3 justify-center">
        <Megaphone className="w-4 h-4 shrink-0" />
        <span className="truncate">{banner.message}</span>
        {banner.link_to && banner.link_label && (
          <Link
            to={banner.link_to}
            className="underline underline-offset-2 font-semibold whitespace-nowrap"
          >
            {banner.link_label} →
          </Link>
        )}
      </div>
    </div>
  );
}
